export const messages = {
  labels: {
    lastMenstrualPeriod: {
      id: 'treatmentSummary.Groups.GynecologicHistory.LastMenstrualPeriod',
      defaultMessage: 'Last Menstrual Period: ',
    },
    menopausalReason: {
      id: 'treatmentSummary.Groups.GynecologicHistory.MenopausalReason',
      defaultMessage: 'Menopause Reason: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.GynecologicHistory.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
